import React from 'react'

export default function AppCheckbox({
  id,
  checked = false,
  onChange,
  disabled = false,
  label,
  description,
  className = '',
  ariaLabel,
}) {
  const generatedId = React.useId()
  const inputId = id || generatedId

  function handleChange(e) {
    if (disabled) return
    onChange?.(e.target.checked)
  }

  return (
    <label
      htmlFor={inputId}
      className={`group inline-flex items-start gap-2.5 select-none ${
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
      } ${className}`}
    >
      <div className="relative flex items-center justify-center pt-0.5">
        <input
          id={inputId}
          type="checkbox"
          checked={Boolean(checked)}
          onChange={handleChange}
          disabled={disabled}
          aria-label={ariaLabel || (typeof label === 'string' ? label : undefined)}
          className="peer sr-only"
        />
        <div
          className={`flex h-4 w-4 items-center justify-center rounded-md border transition-all duration-150 peer-focus-visible:ring-2 peer-focus-visible:ring-primary/30 ${
            checked
              ? 'border-primary bg-primary text-white shadow-xs'
              : 'border-outline-variant/60 bg-surface-container-lowest hover:border-primary/60'
          }`}
        >
          {checked && (
            <svg
              className="h-2.5 w-2.5 fill-none stroke-current stroke-[2.5]"
              viewBox="0 0 14 14"
            >
              <polyline points="2.5 7.5 5.5 10.5 11.5 3.5" />
            </svg>
          )}
        </div>
      </div>
      {(label || description) && (
        <div className="flex flex-col">
          {label && (
            <span className="text-xs font-semibold text-on-surface group-hover:text-primary transition-colors">
              {label}
            </span>
          )}
          {description && (
            <span className="text-[10px] text-on-surface-variant leading-tight">
              {description}
            </span>
          )}
        </div>
      )}
    </label>
  )
}
